<div id="notfound" class="bg-dark">
  <div class="notfound">
    <div class="notfound-404">
      <h1>{{ 'GLOBAL.NOTFOUND.OPS' | translate }}</h1>
    </div>
    <h2 class="text-white">{{ 'GLOBAL.NOTFOUND.404' | translate }} - {{ 'GLOBAL.NOTFOUND.NOT-FOUND' | translate }}</h2>
    <p class="text-white">{{ 'GLOBAL.NOTFOUND.NOT-FOUND-INFO' | translate }}</p>
    <button mat-raised-button color="primary" routerLink="/">
      <i class="rt-icon rt-home-1 me-2"></i>
      {{ 'GLOBAL.NOTFOUND.GOBACK' | translate }}
    </button>
  </div>
</div>
